<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 h-12">
    <div class="p-2 px-4 flex items-center gap-2 bg-white rounded-lg shadow-sm">
      <Users class="w-3.5 h-3.5 text-gray-600" />
      <p class="text-sm text-gray-500">Total Referrers</p>
      <Loader2 class="w-4 h-4 text-gray-600 animate-spin ml-auto" v-if="loading" />
      <p v-else class="text-xl flex-grow text-end">{{ totalReferrers }}</p>
    </div>

    <div class="p-2 px-4 flex items-center gap-2 bg-white rounded-lg shadow-sm">
      <Building2 class="w-3.5 h-3.5 text-gray-600" />
      <p class="text-sm text-gray-500">Companies</p>
      <Loader2 class="w-4 h-4 text-gray-600 animate-spin ml-auto" v-if="loading" />
      <p v-else class="text-xl flex-grow text-end">{{ totalCompanies }}</p>
    </div>

    <div class="p-2 px-4 flex items-center gap-2 bg-white rounded-lg shadow-sm">
      <CircleCheckBig class="w-3.5 h-3.5 text-gray-600" />
      <p class="text-sm text-gray-500">Active Referrers</p>
      <Loader2 class="w-4 h-4 text-gray-600 animate-spin ml-auto" v-if="loading" />
      <p v-else class="text-xl flex-grow text-end">
        {{ activeReferrers }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Users, Building2, CircleCheckBig, Loader2 } from 'lucide-vue-next'

const props = defineProps<{
  totalReferrers: number
  totalCompanies: number
  activeReferrers: number
  loading: boolean
}>()
</script>
